import { Component, EventEmitter, Input, OnInit, Output, inject } from '@angular/core';
import {TranslationService} from '../../core/services/translation.service';
import {AbstractControl, FormBuilder, FormGroup, ReactiveFormsModule, Validators} from '@angular/forms';
import {BaseDataService} from '../../core/services/base-data.service';
import {ContactService} from '../../data/services/contact.service';
import {BaseData} from '../../data/models/base-data.model';
import {SnackbarService} from '../../core/services/snackbar.service';
import {ContactForm} from '../../data/models/contact-form.model';
import {NavigationCommand, NavigationService} from '../../data/services/navigation.service';

import {GeneralErrorsComponent} from "../../core/components/general-errors/general-errors.component";
import {MatError, MatFormField, MatHint, MatLabel} from "@angular/material/form-field";
import {MatOption, MatSelect} from "@angular/material/select";
import {MatInput} from "@angular/material/input";
import {CdkTextareaAutosize} from "@angular/cdk/text-field";
import {LoadingSpinnerComponent} from "../../core/components/loading-spinner/loading-spinner.component";
import {MatButton} from "@angular/material/button";
import {MatCard, MatCardContent} from "@angular/material/card";
import {ApplyIfNotEmptyDirective} from "../../core/directives/apply-if-not-empty.directive";

@Component({
  selector: 'app-contact',
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.scss'],
  imports: [
    GeneralErrorsComponent,
    ReactiveFormsModule,
    MatFormField,
    MatSelect,
    MatOption,
    MatInput,
    CdkTextareaAutosize,
    LoadingSpinnerComponent,
    MatButton,
    MatLabel,
    MatError,
    MatHint,
    MatCard,
    MatCardContent,
    ApplyIfNotEmptyDirective
  ],
  standalone: true
})
export class ContactComponent implements OnInit {
  translationService = inject(TranslationService);
  private formBuilder = inject(FormBuilder);
  private baseDataService = inject(BaseDataService);
  private contactService = inject(ContactService);
  private snackBar = inject(SnackbarService);
  private navigationService = inject(NavigationService);

  contactForm: FormGroup;
  errorsArr: string[] = [];
  contactTypes: BaseData[] = [];
  send: boolean = false;
  isSaving: boolean = false;
  @Input() unauthorized: boolean = false;
  @Input() userBackendId: number = 0;
  @Input() addressForm: FormGroup;
  @Input() emailAddress: string;
  @Output() saved: EventEmitter<boolean> = new EventEmitter<boolean>();

  contactFormModel: ContactForm = null;

  constructor() {
    this.contactTypes = this.baseDataService.getBaseData('contactrequesttypes');
  }

  ngOnInit(): void {
    this.contactForm = this.formBuilder.group({
      reason: ['', Validators.required],
      memo: ['', Validators.required],
    });
    this.send = false;
  }

  onSendContact(): void {
    this.errorsArr = [];
    this.buildContactFormModel();
    this.isSaving = true;
    if (this.contactForm.valid) {
      this.contactService.createContactRequest(this.contactForm.value, this.contactForm, this.errorsArr, this.unauthorized, this.userBackendId, this.contactFormModel)
        .subscribe(
          {
            error: (error) => this.isSaving = false,
            complete: () => {
              this.contactForm.reset();
              this.send = true;
              this.send = true;
              this.saved.emit(true);
              this.navigationService.navigateTo(NavigationCommand.CONTACTOVERVIEW).then((navigated) => {
                if (navigated) {
                  this.snackBar.openSnackbar(this.translationService.getTranslation('saved'));
                }
              });
              this.isSaving = false;
            }
          });
    }
  }

  buildContactFormModel(): void {
    this.contactFormModel = {} as ContactForm;
    if (this.addressForm) {
      const address: AbstractControl = this.addressForm.get('address');
      const person: AbstractControl = this.addressForm.get('person');

      this.contactFormModel.street = address.get('street').value;
      this.contactFormModel.houseno = address.get('houseNo').value;
      this.contactFormModel.zipCode = address.get('zipcode').value;
      this.contactFormModel.city = address.get('city').value;
      this.contactFormModel.country = address.get('country').value?.key;
      this.contactFormModel.additional2 = address.get('extraLine').value;

      this.contactFormModel.firstName = person.get('firstName').value;
      this.contactFormModel.lastName = person.get('lastName').value;
      this.contactFormModel.salutation = person.get('salutation')?.value['key'];
      this.contactFormModel.title = person.get('title').value;

      this.contactFormModel.email = this.emailAddress;
    }
  }
  isValidEmail(email: string): "empty" | "valid" | "invalid" {
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

    if (!email || email.trim() === "") {
      console.log("isValidEmail: empty");
      return "empty";
    }

    const isValid = emailRegex.test(email);
    console.log("isValidEmail:", isValid ? "valid" : "invalid");
    return isValid ? "valid" : "invalid";
  }

  protected readonly document = typeof document === 'object' ? document : null;
}
